import {h, Component, Fragment} from "preact";


export function ColumnTitleRow({children}) {
	return <div class="cl-plc-col-ttl-row flex h-8 items-center justify-between bg-kobaaccent-400 pl-3 text-white">{children}</div>
}

export function ColumnTitleLabel({children}) {
	return <div class="cl-plc-col-ttl-lbl text-sm capitalize text-slate-950">{children}</div>
}

export function ColumnContent({children}) {
	return <div class="cl-plc-col-content flex flex-col items-center justify-between gap-3 bg-slate-100 p-3 text-slate-950">{children}</div>
}

export function ContentRow({children}) {
	return <div class="cl-plc-content-row h-7 w-full flex-none">{children}</div>
}
export function ContentRowFlex({children}) {
	return <div class="cl-plc-content-row-f flex h-7 w-full flex-none gap-2">{children}</div>
}

export function InputContainer({children}) {
	return <div class="cl-plc-input-cont h-full w-full rounded-lg bg-slate-300">{children}</div>
}
export function SubmitButton({children, onClick}) {
	return <div class="cl-plc-submit-btn flex h-7 w-7 flex-none items-center justify-center rounded-lg bg-kobaaccent-400 font-extrabold text-white cursor-pointer" onClick={onClick}>
		<span class="pb-0.5">&gt;</span>
	</div>
}

export function HelperText({children}) {
	return <div class="cl-plc-hlp-txt flex grow items-center px-2 text-center text-sm leading-4">{children}</div>
}

export function ErrorText({children}) {
	return <div class="cl-plc-hlp-txt flex grow items-center px-2 text-center text-sm leading-4 text-red-600">{children}</div>
}

export function TicketTopRow({children}) {
	return <div class="cl-plc-tkt-toprow fn-ticket-top-row flex flex-wrap w-full rounded-t-xl overflow-hidden bg-slate-100 border-b border-b-slate-300 items-center text-sm">
		{children}
	</div>
}

export function ColumnTicketWrappper({children}) {
	return <div class="cl-plc-col-tkt-wrap text-slate-950">{children}</div>
}